module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/index/avatar-female1-7fe5f260c15bdc15a0b741d53c222c3c.png";